import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import _isEmpty from 'lodash/isEmpty';
import ResourceCard from '../ResourceCard';
import HeroContext from '../../PageContext';

function FeaturedResources() {
  const { featuredResources } = useContext(HeroContext);
  if (_isEmpty(featuredResources)) return null;
  return (
    <Grid item xs={12} sm={12} md={4}>
      <Grid container>
        {featuredResources.slice(0, 4).map((item, index) => (
          <ResourceCard
            data={item}
            key={item.slug}
            isTextOnly
            isLast={index === 3}
          />
        ))}
      </Grid>
    </Grid>
  );
}

export default FeaturedResources;
